import React, { useState } from "react";
import { ReactComponent as Close } from "assets/svgs/close.svg";
import { ReactComponent as Trash } from "assets/svgs/trash.svg";
import { toast } from "react-toastify";
import { useWishlist } from "hooks/useStore";
import Modal from "components/modal";
import Input from "components/input";
import { validateWishlistName } from "helpers/wishlist";
import clsx from "clsx/lite";

const EditListModal = ({ isOpen, toggle, list }) => {
	const { removeList, updateListDescription, savedLists } = useWishlist(["removeList", "updateListDescription", "savedLists"]);
	const [listName, setListName] = useState(list.lname);
	const [listDescription, setListDescription] = useState(list.lnote);
	const [error, setError] = useState();
	const [isLoading, setIsLoading] = useState(false);

	const onNameChange = (e) => {
		setListName(e.target.value);
		setError(validateWishlistName(e.target.value, savedLists, [], list.lid));
	};

	const onDescriptionChange = (e) => {
		setListDescription(e.target.value);
	};

	const handleDeleteList = async () => {
		setIsLoading(true);
		const res = await removeList(list.lid);
		if (res.errors) {
			toast.error("Error removing list");
		} else {
			toast.success("List removed successfully");
			toggle();
		}
		setIsLoading(false);
	};

	const handleUpdateList = async () => {
		setIsLoading(true);
		const res = await updateListDescription(list.lid, listName, listDescription);
		if (res.errors) {
			toast.error("Error updating list");
		} else {
			toast.success("List updated successfully");
			toggle();
		}
		setIsLoading(false);
	};

	const isUpdateButtonDisabled =
		error || isLoading || (listName === list.lname && (listDescription === list.lnote || listDescription.trim() === ""));

	return (
		<Modal
			isOpen={isOpen}
			close={toggle}
			hideHeader
			label="Edit Wishlist"
			className="text-center !w-full md:!max-w-[408px]"
		>
			<div className="p-5 flex flex-col gap-6">
				<div className="w-full flex justify-between">
					<h4 className="font-medium">Edit List</h4>
					<button className="p-1 ml-auto mb-auto" onClick={toggle}>
						<Close className="size-5" />
					</button>
				</div>
				<div className="flex flex-col gap-5">
					<Input
						onChange={(e) => onNameChange(e)}
						error={error} name="name" label="Name"
						value={listName}
					/>
					<div className="relative">
						<label htmlFor="description"
							className={clsx("absolute text-xs top-0 left-1.5 p-3", error ? "text-red-500" : "text-gray-600")}>
							Description
						</label>
						<textarea
							id="description"
							name="description"
							placeholder="Give your list a description"
							value={listDescription}
							rows={5}
							onChange={(e) => onDescriptionChange(e)}
							className={clsx(
								"border border-beige focus:outline-beige resize-none shadow p-3 w-full pt-7 pl-4",
								listDescription ? "border-opacity-100" : "border-opacity-30",
							)}
						/>
					</div>
					<div className="flex w-full gap-2">
						<button onClick={handleUpdateList} disabled={isUpdateButtonDisabled} className="btn-primary w-full">
							{isLoading ? "Updating..." : "Update"}
						</button>
						<button onClick={handleDeleteList} disabled={isLoading} className="p-5 border border-red">
							<Trash className="scale-90" />
						</button>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default EditListModal;
